//-----------------------------------------------------------MASQUE DE SAISIE---------------------------------------------------------

function Valide_Texte(ele) {
	var testval=new RegExp("[<>\$:\*\?|{}µ%£#&=²]");
 	return testval.test(ele.value);
}

function Valide_Entier(ele, enableNegative) {
	var reg = enableNegative ? /^[-]?\d+$/ : /^\d+$/;
	return reg.test(ele.value);
}

function Valide_Decimal(ele) {
	var reg = /^[-]{0,2}\d+[.]\d+$/;
	return reg.test(ele.value);
}

function Valide_Tel(val,pays) {
	switch (pays.toUpperCase()) {
		case 'AE':
			val   = $.trim(val);
			isValid = (/^(((\+|00)?971[\s\.-]?(\(0\)[\s\.-]?)?|0)(\(5(0|2|5|6)\)|5(0|2|5|6)|2|3|4|6|7|9)|60)([\s\.-]?[0-9]){7}$/).test(val);
			break;

		case 'BG':
			val   = val.replace(/\+|\s|-|\/|\(|\)/gi,'');
			isValid = (/^(0|359|00)(((700|900)[0-9]{5}|((800)[0-9]{5}|(800)[0-9]{4}))|(87|88|89)([0-9]{7})|((2[0-9]{7})|(([3-9][0-9])(([0-9]{6})|([0-9]{5})))))$/).test(val);
			break;

		case 'BR':
			val   = $.trim(val);
			isValid = (/^(([\d]{4}[-.\s]{1}[\d]{2,3}[-.\s]{1}[\d]{2}[-.\s]{1}[\d]{2})|([\d]{4}[-.\s]{1}[\d]{3}[-.\s]{1}[\d]{4})|((\(?\+?[0-9]{2}\)?\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-.\s]?\d{4}))$/).test(val);
			break;

		case 'CN':
			val   = $.trim(val);
			isValid = (/^((00|\+)?(86(?:-| )))?((\d{11})|(\d{3}[- ]{1}\d{4}[- ]{1}\d{4})|((\d{2,4}[- ]){1}(\d{7,8}|(\d{3,4}[- ]{1}\d{4}))([- ]{1}\d{1,4})?))$/).test(val);
			break;

		case 'CZ':
			isValid = /^(((00)([- ]?)|\+)(420)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(val);
			break;

		case 'DE':
			val   = $.trim(val);
			isValid = (/^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/).test(val);
			break;

		case 'DK':
			val   = $.trim(val);
			isValid = (/^(\+45|0045|\(45\))?\s?[2-9](\s?\d){7}$/).test(val);
			break;

		case 'ES':
			val   = $.trim(val);
			isValid = (/^(?:(?:(?:\+|00)34\D?))?(?:5|6|7|8|9)(?:\d\D?){8}$/).test(val);
			break;

		case 'FR':
			val   = $.trim(val);
			isValid = (/^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/).test(val);
			break;

		case 'GB':
			val   = $.trim(val);
			isValid = (/^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/).test(val);
			break;

		case 'IN':
			val   = $.trim(val);
			isValid = (/((\+?)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/).test(val);
			break;

		case 'MA':
			val   = $.trim(val);
			isValid = (/^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/).test(val);
			break;

		case 'MC':
			val   = $.trim(val);
			isValid = (/^(?:(?:(?:\+|00)337[ ]?(?:\(0\)[ ]?)?)|[0-9]){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){2}\d{2}$/).test(val);
			break;

		case 'NL':
			val   = $.trim(val);
			isValid = (/^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/gm).test(val);
			break;

		case 'PK':
			val   = $.trim(val);
			isValid = (/^0?3[0-9]{2}[0-9]{7}$/).test(val);
			break;

		case 'RO':
			isValid = (/^(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/g).test(val);
			break;

		case 'RU':
			isValid = (/^((8|\+7|007)[\-\.\/ ]?)?([\(\/\.]?\d{3}[\)\/\.]?[\-\.\/ ]?)?[\d\-\.\/ ]{7,10}$/g).test(val);
			break;

		case 'SK':
			isValid = /^(((00)([- ]?)|\+)(421)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(val);
			break;

		case 'TH':
			isValid = (/^0\(?([6|8-9]{2})*-([0-9]{3})*-([0-9]{4})$/).test(val);
			break;

		case 'VE':
			val   = $.trim(val);
			isValid = (/^0(?:2(?:12|4[0-9]|5[1-9]|6[0-9]|7[0-8]|8[1-35-8]|9[1-5]|3[45789])|4(?:1[246]|2[46]))\d{7}$/).test(val);
			break;

		case 'US':

		case 0 :
			val   = $.trim(val);
			isValid = (/[0-9]+/).test(val);
			break;

		default:
			isValid = (/^(?:(1\-?)|(\+1 ?))?\(?(\d{3})[\)\-\.]?(\d{3})[\-\.]?(\d{4})$/).test(val);
			break;
	}
	return isValid;
}

function Valide_Mail(val) {
	var reg = new RegExp('^[0-9a-z._-]+@{1}[0-9a-z.-]{2,}[.]{1}[a-z]{2,5}$','i');
	return reg.test(val);
}

function Valide_Cp(val) {
	var reg = new RegExp(/^[0-9]{5}/gi);
	return reg.test(val);
}

function Valide_Url(val) {
	var reg = new RegExp(/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/);
	return reg.test(val);
}

function Valide_Heure(ele) {
	var reg= new RegExp(/^([01][0-9]|2[0-3]):([0-5][0-9])$/);
	return reg.test(ele.value);
}
function Valide_Heure_byval(value) {
	var reg= new RegExp(/^([01][0-9]|2[0-3]):([0-5][0-9])$/);
	return reg.test(value);
}

function ValideMaj_Heure(ele, popupmsg) {
	// paramètres : ele=element à tester, popupmsg=0/1 pour afficher ou non les alertes
	var reg1= new RegExp(/^([01][0-9]|2[0-3])([0-5][0-9])$/); 	// Formats testés : 115 pour 1h15, 0115 pour 1h15, 1915 pour 19h15, 2320 pour 23h20 etc...
	var reg2= new RegExp(/^([01][0-9]|2[0-3]):([0-5][0-9])$/);	// Formats testés : 1:15 pour 1h15, 01:15 pour 1h15, 19:15 pour 19h15, 23:20 pour 23h20 etc...
	valeur = ele.value;

	// Vérification de la présence des ":", si absence alors on les rajoute
	if (reg1.test(valeur)) {
		if (valeur.length==3) valeur = '0'+valeur;
		valeur = valeur.substring(0,2)+':'+valeur.substring(2,4);
	}
	// Vérification de la cohérence de l'heure, si erreur alors on alerte
	if (reg2.test(valeur)==false) {
		if (popupmsg==1) alert('Erreur de saisie sur l\'heure.');
		return false
	} else {
		ele.value = valeur;
		return true;
	}

}

function completeDecimal(ele) {
	if (Valide_Entier(ele)) ele.value = ''+ele.value+'.00';
}


function champHeureSuivant(enCours, suivant, limite) {
  if (ValideMaj_Heure(enCours)) $(suivant).focus();
}

//--------------------------------------------------------------------DATES-------------------------------------------------------
function Valide_Date(d) {
	// Cette fonction vérifie le format JJ/MM/AAAA saisi et la validité de la date.
  // Le séparateur est défini dans la variable separateur
  if (d==undefined) return 0;
  var amin=1900; // année mini
  var amax=2030; // année maxi
  var separateur="/"; // separateur entre jour/mois/annee
  var j=(d.substring(0,2));
  var m=(d.substring(3,5));
  var a=(d.substring(6));
  var ok=1;
  if ( ((isNaN(j))||(j<1)||(j>31)) && (ok==1) ) {
     ok=0;
  }
  if ( ((isNaN(m))||(m<1)||(m>12)) && (ok==1) ) {
     ok=0;
  }
  if ( ((isNaN(a))||(a<amin)||(a>amax)) && (ok==1) ) {
     ok=0;
  }
  if ( ((d.substring(2,3)!=separateur)||(d.substring(5,6)!=separateur)) && (ok==1) ) {
     ok=0;
  }
  if (ok==1) {
    var d2=new Date(a,m-1,j);
    j2=d2.getDate();
    m2=d2.getMonth()+1;
    a2=d2.getFullYear();
    if (a2<=100) {a2=1900+a2}
    if ( (j!=j2)||(m!=m2)||(a!=a2) ) {
       ok=0;
  	}
  }
  return ok;
}


function DecomposeDate(LeParam1){

	// Sépare les jours, les mois et les années dans une date de type "22/05/1981"
	// Renvoye le tout dans un tableau de taille 3

	LeRetour = new Array(3);
	LeJour="";
	LeMois="";
	LeAnnee="";

	// Extraction du jour
	i=0;
	while((LeParam1.charAt(i)!="/")&&(i<10)){
		LeJour+=LeParam1.charAt(i);
		i++;
	}
	if(LeJour.charAt(0)=="0"){
		LeJour=LeJour.charAt(1);
	}
	LeParam1=LeParam1.substring(i+1,LeParam1.length);

	// Extraction du mois
	i=0;
	while((LeParam1.charAt(i)!="/")&&(i<10)){
		LeMois+=LeParam1.charAt(i);
		i++;
	}
	if(LeMois.charAt(0)=="0"){
		LeMois=LeMois.charAt(1);
	}
	LeParam1=LeParam1.substring(i+1,LeParam1.length);


	// Extraction de l'année
	LeAnnee=LeParam1;
	LeRetour[0]=LeJour;
	LeRetour[1]=LeMois;
	LeRetour[2]=LeAnnee;
	return LeRetour;
}

function DateAnglaise(LeParam1,LeParam2){

	if (!LeParam1) {
        LeParam1= today();
	}

    LaDate = new Array(3);
        LaDate = DecomposeDate(LeParam1);

        LeRetour = LaDate[2] + LeParam2;
        if (LaDate[1] < 10) LeRetour += '0';
        LeRetour += LaDate[1] + LeParam2;
        if (LaDate[0] < 10) LeRetour += '0';
        LeRetour += LaDate[0];
	    return LeRetour;
}

function ComparerDates(LeParam1,LeParam2){
	// Compare 2 dates au format jj/mm/aaaa
	// Renvoye 0 si égalité, 1 si la première est supérieure, sinon 2
	var LeParam1 = DateAnglaise(LeParam1,"/"); // Ne pas oublier d'utiliser cette fonction
	var LeParam2 = DateAnglaise(LeParam2,"/"); // pour convertir en date anglaise, sinon le 05/07/2003 sera compris "7 mai 2003" par JavaScript

	LeParam1 = Date.parse(LeParam1);
	LeParam2 = Date.parse(LeParam2);

	if (LeParam1 == LeParam2) return 0;

	if (LeParam1 > LeParam2) return 1;
	else return 2;
}

function ComparerAnnee(LeParam1,LeParam2){
	LaDate1 = new Array(3);
	LaDate1 = DecomposeDate(LeParam1);

	LaDate2 = new Array(3);
	LaDate2 = DecomposeDate(LeParam2);

	if (LaDate1[2] != LaDate2[2]) return 0;
	else return 1;
}

function DernierJourDuMois(mois,annee) {
	var dd = new Date(annee, mois, 0);
	return dd.getDate();
}

function premierJourSemaine(d) {
  d = new Date(d);
  var firstday = new Date(d.setDate(d.getDate() - d.getDay()+1));
  return firstday;
}

function DernierJourSemaine(d) {
  var firstday 	= premierJourSemaine(d);
  var lastday 	= new Date(firstday.setDate(firstday.getDate() - firstday.getDay()+7));
  return lastday;
}

/*
  #No parameters
  returns a date with this format DD-MM-YYYY
*/
function today()
{
    var d = new Date();
    var month = d.getMonth()+1;
    var day = d.getDate();

    var output = (day<10 ? '0' : '') + day + "/"
        + (month<10 ? '0' : '') + month + '/'
        + d.getFullYear();

    return output;
}

//--------------------------------------------------------------DIVERS-------------------------------------------------------------------

function nompropre(mot) {
 	var m=mot.charAt(0).toUpperCase()+mot.substring(1).toLowerCase();
    return m;
}

function majPrenom(id){
    return id.value.toLowerCase().replace( /(^|\s|-)([a-z])/g , function(m,p1,p2){ return p1+p2.toUpperCase(); } );
};

function apostrophe(strchaine) {
	var a, tmp;
	tmp = "";
	a = strchaine;

	for(var i = 0; i < a.length; i++){
		tmp = tmp + a.charAt(i);
	    if (a.charAt(i) == "'"){
	    	tmp = tmp.replace("'"," ");
	    }
	    if (a.charAt(i) == '"'){
	    	tmp = tmp.replace('"',' ');
	    }
	}
	a = tmp;
	return a;
}

//Remplace la virgule d'un nombre décimal par un point
function remp_virg(strchaine) {
	var a, tmp;
	tmp = "";
	a = strchaine;

	for(var i = 0; i < a.length; i++){
	tmp = tmp + a.charAt(i);
	    if (a.charAt(i) == ","){
	    	tmp = tmp.replace(",",".");
	    }
	}
	a = tmp;
	return a;
}

//Supprime les espaces
function remp_space(strchaine) {
	var a, tmp;
	tmp = "";
	a = strchaine;

	for(var i = 0; i < a.length; i++){
	tmp = tmp + a.charAt(i);
	    if (a.charAt(i) == " "){
	    	tmp = tmp.replace(" ","");
	    }
	}
	a = tmp;
	return a;
}

// Supprime les espaces de début et de fin façon mysql
function trim(chaine) {
	return chaine.replace(/^\s+/g,'').replace(/\s+$/g,'')
}

function gid(repere){
	return document.getElementById(repere);
}


//Fonctions Affiche/Masque
function shp(partie){
	if (gid(partie).style.display=="block"){
		gid(partie).style.display="none";
	} else {
		gid(partie).style.display="block";
	}
}
//Fonctions Affiche/Masque ligne tableau
function shp2(partie){
	if (gid(partie)!=null) {
		if (gid(partie).style.display!="none"){
			gid(partie).style.display="none";
		} else {
			gid(partie).style.display="";
		}
	}
}
function shp3(idTable, idAge) {
	var lst_tr = gid(idTable).getElementsByTagName("tr");
	for (i=0; i<lst_tr.length; i++) {
		if ((lst_tr[i].id!='')&&(lst_tr[i].id.substr(0,idAge.length)==idAge)) {
			if (document.getElementById(lst_tr[i].id).style.display!="none"){
				document.getElementById(lst_tr[i].id).style.display="none";
			} else {
				document.getElementById(lst_tr[i].id).style.display="";
			}
		}
	}
}
// Fonction Affiche / Masque toutes les lignes d'un tableau
// Paramètres : début de l'id des tr à modifier, aff : none pour masquer, "" pour afficher
function shpAll(elt, idTable, idTr) {
	var mode = 0;
	var disp = '';
	if (elt.className=="fa fa-plus-square-o") {
		elt.title="Tout enrouler"; disp = '';
		$("#"+idTable+" .fa-plus-square-o").toggleClass( "fa-plus-square-o fa-minus-square-o" );
	}
	else {
		elt.title="Tout dérouler";
		disp = 'none';
		$("#"+idTable+" .fa-minus-square-o").toggleClass( "fa-plus-square-o fa-minus-square-o" );
	};

	var lst_tr = gid(idTable).getElementsByTagName("tr");
	for (i=0; i<lst_tr.length; i++)
		if ((lst_tr[i].id!='')&&(lst_tr[i].id.indexOf(idTr)>-1)) gid(lst_tr[i].id).style.display=disp;
}

//Fonctions de changement d'image (utilisée dans un enroule déroule
function changeImage(idimg,img1,img2) {
	if (gid(idimg).src.indexOf(img1)==-1) gid(idimg).src = img1;
	else gid(idimg).src = img2;
}

function changePlusMoins(ele) {
	if (ele.className=="fa fa-plus-square-o") ele.className = "fa fa-minus-square-o";
	else ele.className = "fa fa-plus-square-o";
}


//Format de nombre
function format(valeur,decimal,separateur) {
	var deci=Math.round( Math.pow(10,decimal)*(Math.abs(valeur)-Math.floor(Math.abs(valeur)))) ;
	var val=Math.floor(Math.abs(valeur));
	if ((decimal==0)||(deci==Math.pow(10,decimal))) {val=Math.floor(Math.abs(valeur)); deci=0;}
	var val_format=val+"";
	var nb=val_format.length;
	for (var i=1;i<4;i++) {
		if (val>=Math.pow(10,(3*i))) {
			val_format=val_format.substring(0,nb-(3*i))+separateur+val_format.substring(nb-(3*i));
		}
	}
	if (decimal>0) {
		var decim="";
		for (var j=0;j<(decimal-deci.toString().length);j++) {decim+="0";}
		deci=decim+deci.toString();
		val_format=val_format+"."+deci;
	}
	if (parseFloat(valeur)<0) {val_format="-"+val_format;}
	return val_format;
}


//---------------------------------------------------------------IMPRESSION & POPUP----------------------------------------------------------
// Fonctionalités d'impression
var gAutoPrint = true;

function printSpecial(lbl){
	window.print();
}

function printSpecialReload(lbl,fic){
	var tmp = lbl;
	if (!tmp) { tmp=''; }

	if (document.getElementById == null) {
		return;
	}
	var printReadyElem = document.getElementById("printReady"+tmp);
	if (printReadyElem == null) {
		window.alert("Pas de section imprimable définie dans cette page.");
		return;
	}

	var printWin = window.open("","printSpecial", "scrollbars=yes", "toolbar=no", "menubar=no", "status=no");
	$.ajax({
		url 		: fic,
		async: false,
		type 		: 'POST',
		data 		: "prt=1",
		dataType 	: 'html',
		success 	: function(code_html, statut){
			var html = '<HTML>\n<HEAD>\n';

			if (document.getElementsByTagName != null) {
				var headTags = document.getElementsByTagName("head");
				if (headTags.length > 0) {
					html += headTags[0].innerHTML;
				}
			}
			html += '\n</HE' + 'AD>\n<BODY class="nude">\n';

			var printCritElem = document.getElementById("printCrit");
			if (printCritElem != null) {
				html += printCritElem.innerHTML;
			}

			html += code_html;
			html += '\n<SCRIPT>window.print();</SCRIPT>';
			html += '\n</BO' + 'DY>\n</HT' + 'ML>';
			
			printWin.document.open();
			printWin.document.write(html);
			printWin.document.close();
		}
	})
}

function printSpecial_bilan(lbl){
	var tmp = lbl;
	if (!tmp) { tmp=''; }
	if (document.getElementById != null) {
		var html = '<HTML>\n<HEAD>\n';

		if (document.getElementsByTagName != null) {
			var headTags = document.getElementsByTagName("head");
			if (headTags.length > 0) {
				html += headTags[0].innerHTML;
			}
		}
		html += '\n</HE' + 'AD>\n<BODY class="nude">\n';

		var printCritElem = document.getElementById("printCrit");
		if (printCritElem != null) {
			html += printCritElem.innerHTML;
		}

		var printReadyElem = document.getElementById("printReady"+tmp);
		if (printReadyElem != null) {
			html += printReadyElem.innerHTML;
		} else {
			alert("Pas de section imprimable définie dans cette page.");
			return;
		}
		html += '\n</BO' + 'DY>\n</HT' + 'ML>';

		var printWin = window.open("","printSpecial", "scrollbars=yes", "toolbar=no", "menubar=no", "status=no");
		printWin.document.open();
		printWin.document.write(html);
		printWin.document.close();
		if (gAutoPrint){
			printWin.print();
		} else {
			alert("Désolé, les fonctionalité d'impression ne sont disponible que sur des navigateurs récents.");
		}

	}
}

function Popup(page, h, l) {
	if (h==undefined) {h=170;hauteur=Math.round((screen.availHeight-h)/2);}
	else hauteur = h;
	if (l==undefined) {l=450;largeur=Math.round((screen.availWidth-l)/2);}
	else largeur = l;
	window.open(page,"","toolbar=no, location=no, directories=no, status=no, scrollbars=yes, resizable=no, menubar=no, top="+hauteur+", left="+largeur+", width="+l+", height="+h);
}

function Popup_Suppr(page) {
	h=170;
	l=450;
	hauteur=Math.round((screen.availHeight-h)/2);
	largeur=Math.round((screen.availWidth-l)/2);
    	window.open(page,"","toolbar=no, location=0, location=no, directories=no, status=no, scrollbars=no, resizable=no, menubar=no, top="+hauteur+", left="+largeur+", width="+l+", height="+h);
}

//----------------------------------------------------Mise à jour via XMLHTTPRequest----------------------------------------------

function XHR_Start() {
	// Instanciation de l'objet XMLHttpRequest
	var xhr = null;
	if (window.XMLHttpRequest || window.ActiveXObject) {
		if (window.ActiveXObject) {
			try {
				xhr = new ActiveXObject("Msxml2.XMLHTTP");
			} catch(e) {
				xhr = new ActiveXObject("Microsoft.XMLHTTP");
			}
		} else {
			xhr = new XMLHttpRequest();
		}
	} else {
		alert("Votre navigateur ne supporte pas l'objet XMLHTTPRequest...");
		return null;
	}
	return xhr;
}

function getXMLHttpRequest() {
	var xhr = null;
	if (window.XMLHttpRequest || window.ActiveXObject) {
		if (window.ActiveXObject) {
			try 		{ xhr = new ActiveXObject("Msxml2.XMLHTTP"); }
			catch(e) 	{ xhr = new ActiveXObject("Microsoft.XMLHTTP"); }
		} else xhr = new XMLHttpRequest();
	} else {
		alert("Votre navigateur ne supporte pas l'objet XMLHTTPRequest...");
		return null;
	}

	return xhr;
}

function majSelect(nomForm, nomSelectIni, nomSelectIni2, nomSelectFin, fichierRequete, action, valInit, ddeb, dfin) {
  var value 	= nomSelectIni.value;
  var xhr   	= getXMLHttpRequest();
  var select1 = '';
	var select2 = '';

	if (nomSelectIni!='') {
		select1	= document.getElementById(nomSelectIni);
		newId 	= select1.value;
		if (valInit!='') oldId = valInit;
		else oldId = '';
	} else {
		newId = valInit;
		oldId = '';
	}

	strParam = "id="+newId
	findId = action;
	if (findId!=''||findId==0) strParam += "&findId="+findId;

	if (nomSelectIni2!='') {
		select2	=	document.getElementById(nomSelectIni2);
		newId2 	= 	select2.value;
		strParam += '&agt='+newId2;
	}

	if (oldId!='') strParam+="&oldId="+oldId;

	if (ddeb!=''&&ddeb!=undefined&&Valide_Date(ddeb) && dfin!=''&&dfin!=undefined&& Valide_Date(dfin)) strParam += "&ddeb="+ddeb+"&dfin="+dfin;

    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 0)) {
            readData(xhr.responseXML,nomSelectFin);
        }
    };

    fichierRequete += fichierRequete.indexOf('?') > -1 ? '&' : '?';
    xhr.open("GET", ""+fichierRequete+strParam, false);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(strParam);
}


function readData(oData,nomSelectFin) {
    var groups = oData.getElementsByTagName("optgroup");
	var oSelect = document.getElementById(nomSelectFin);
	var oOption, oInner;
	if( !oSelect ) {
		return;
	}
	oSelect.innerHTML = "";

    if (groups.length > 0){
        // Create <option id="0">...</option>
        var nodes   = oData.getElementsByTagName("item");
        if (nodes.length > 0){
            console.log('ici');
            var firstNode= oData.getElementsByTagName("item")[0];
            if (firstNode.getAttribute("id") == 0){
                 createSelect([firstNode],oSelect);
            }
        }
        // Iterate over groups
		for (var i=0, b=groups.length; i<b; i++) {
			oOptGroup = document.createElement("OPTGROUP");
            oOptGroup.setAttribute('label',groups[i].getAttribute("label"));
			oSelect.appendChild(oOptGroup);

            var nodes  = groups[i].childNodes;
           	createSelect(nodes,oOptGroup);
            oSelect.appendChild(oOptGroup);
        }
	} else {
        var nodes   = oData.getElementsByTagName("item");
		createSelect(nodes,oSelect);
	}
}

function createSelect(nodes,oParent){
    for (var j=0, c=nodes.length; j<c; j++) {
        oOption = document.createElement("option");
        oInner  = document.createTextNode(nodes[j].getAttribute("name"));
        oOption.value = nodes[j].getAttribute("id");
        if (nodes[j].getAttribute("select")=="yes") {
            oOption.selected = true;
        }
        oOption.appendChild(oInner);
        oParent.appendChild(oOption);
    }
}

function majDiv(nomDiv, divNumPage, divNumPageHaut, urlFic, data, mode) {
	var xhr = XHR_Start();
	xhr.open(mode, ""+urlFic, true);
	xhr.onreadystatechange = function() {
	    if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 0)){
		    document.getElementById(nomDiv).innerHTML = xhr.responseText;
				if ((divNumPageHaut!=null)&&(divNumPage!=null)) document.getElementById(divNumPageHaut).innerHTML = document.getElementById(divNumPage).innerHTML;
			} else {
				var str ='<div align=center style="margin-top:50px;"><img src="./img/ajaxwait.gif" border=0 /></div>';
				document.getElementById(nomDiv).innerHTML = str;
			}
	}
	xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
	xhr.send(data);
}

function majDivAvecScript(nomDiv, urlFic, data) {
	var xhr = XHR_Start();
	xhr.open("POST", ""+urlFic, true);
	xhr.onreadystatechange = function() {
	    if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 0)){
	       	document.getElementById(nomDiv).innerHTML = xhr.responseText;
			var e = document.getElementById(nomDiv);
			var scripts = e.getElementsByTagName("script");
			for(var i=0; i < scripts.length;i++)
			{
				/*Sous IE il faut faire un execScript pour que les fonctions soient définie en globale*/
				if (window.execScript)
				{ /*On replace les éventuels com' html car IE n'aime pas ça*/
					window.execScript(scripts[i].text.replace('<!--',''));
				} else {  /*Sous les autres navigateurs on fait un window.eval*/
					window.eval(scripts[i].text);
				}
			}
	    } else {
	    	var str ='<div align=center style="margin-top:50px;"><img src="./img/ajaxwait.gif" border=0 /></div>';
	    	document.getElementById(nomDiv).innerHTML = str;
	    }
	}
	xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf8");
	xhr.send(data);
}

function majTrAvecScript(nomTr, urlFic, data, nbCol) {
	var xhr = XHR_Start();
	xhr.open("POST", ""+urlFic, true);
	xhr.onreadystatechange = function() {
	    if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 0)){
	       	$("#"+nomTr).replaceWith(xhr.responseText);
	    } else {
	    	var str ='<tr id='+nomTr+'><td colspan='+nbCol+'><div align=center style="margin-top:50px;"><img src="./img/ajaxwait.gif" border=0 /></div></td></tr>';
	    	$("#"+nomTr).replaceWith(str);
	    }
	}
	xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf8");
	xhr.send(data);
}

function majVar(url, idSession, idSession2, str) {
	var xhr = XHR_Start();		//On crée un nouvel objet XMLHttpRequest
	//Appel du fichier externe
	if (idSession2 != '') {
		xhr.open("GET", "./request/req_maj_session.php?id="+idSession+"&id2="+idSession2+"&txt="+str, true);
	} else {
		xhr.open("GET", "./request/req_maj_session.php?id="+idSession+"&id2=null&txt="+str, true);
	}
	xhr.send(); 				// On ne précise rien d'autre, la page n'est pas affichée mais les variables de sessions sont modifiées
}

function majBDD(url, val) {
	var xhr = XHR_Start();
	xhr.open("GET", url+"?val="+val, true);
	xhr.send();
}

function majBDDPost(url, val) {
	var xhr = XHR_Start();
	xhr.open("POST", url, true);
	xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf8");
	xhr.send(val);
}

function afficheWait(divId) {
	document.getElementById(divId).innerHTML='<div align=center style="margin-top:50px;"><img src="./img/ajaxwait.gif" border=0 /></div>';
}

function init_btn(btnClic, divName, valeur, inpName) {
	if (!inpName) inpName = "filtreValue";
	nomDiv = document.getElementById(divName);
	Btn = nomDiv.getElementsByTagName("a");
	for (i=0;i<Btn.length;i++) {
		if (Btn[i].id == btnClic ) {
			document.getElementById(Btn[i].id).setAttribute("class","actif");
			document.getElementById(Btn[i].id).setAttribute("className","actif");
		} else {
			document.getElementById(Btn[i].id).setAttribute("class","");
			document.getElementById(Btn[i].id).setAttribute("className","");
		}
	}
	document.getElementById(inpName).value = valeur;
}

/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
/* 					Gestion des select & radios 	 						*/
/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */

/* ------------------------------------------------------------------------ */
/* Nom : getEltSelect														*/
/* ------------------------------------------------------------------------	*/
/* Description : 	renvoie la liste des éléments sélectionnés 				*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- nameElt : nom du champ à manipuler						*/
/* ------------------------------------------------------------------------	*/
function getEltSelect(nameElt) {
	var form = document.getElementById(nameElt);
	var formElems = form.getElementsByTagName('input');
	var ele='';
	var nbEle=0;
	for (var j = 0; j < formElems.length; j++) {
		if (formElems[j].type == 'checkbox' && formElems[j].checked==true) {
			if (nbEle>0) ele+=',';
			ele+=formElems[j].value;
			nbEle++;
		}
	}
	return ele;
}

/* ------------------------------------------------------------------------ */
/* Nom : getRadioSelect														*/
/* ------------------------------------------------------------------------	*/
/* Description : 	renvoie l'élément sélectionné					 		*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- nameElt : nom du champ à manipuler						*/
/* ------------------------------------------------------------------------	*/
function getRadioSelect(nameElt) {
	var ele = '';
	var radios = document.getElementsByName(nameElt);
	for (var j = 0, length = radios.length; j < length; j++) {
		if (radios[j].checked) {
			ele = radios[j];
			break;
		}
	}
	return ele;
}

function jump(h){
    var top = document.getElementById(h).offsetTop; //Getting Y of target element
    window.scrollTo(0, top);                        //Go there.
}

/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
/* 					Gestion des filtres				 						*/
/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
function majAge(typeSel) 		{ majSelect('critere'	,'client',''	,'agence'	,'./request/req_activite_select_agence.php' ,typeSel ); }
function majAge2(typeSel) 		{ majSelect('critereHaut'	,'client',''	,'agence'	,'./request/req_activite_select_agence.php' ,typeSel ); }
function majUtil(oldId) 		{ majSelect('critere'	,'agence',''	,'util'		,'./request/req_activite_select_user.php'	,gid("client").value	,oldId , gid("dateDeb").value, gid("dateFin").value ); }
function majGest(oldId) 		{ majSelect('critereHaut'	,'agence',''	,'gestionnaire'		,'./request/req_activite_select_gest.php'	,gid("client").value	,oldId , gid("dateDeb").value, gid("dateFin").value ); }
function majSelTypeActivite () 	{ majSelect('critere'	,'agence'
	,''	,'selTypActivite'	,'./request/req_activite_select_typeactivite2.php'													); }
function majSelActivite () 		{ majSelect('critere'	,'agence'
	,''	,'selActivite'		,'./request/req_activite_select_typecontact2.php'	,document.getElementById('selTypActivite').value); }
function majSelOrigine () 		{ majSelect('critere'	,'agence'
	,''	,'selOrigine'		,'./request/req_activite_select_origine2.php'		,document.getElementById('selTypActivite').value); }
function majSelOrigine2 () 		{ majSelect('critere'	,'agence'
	,''	,'selOrigine'		,'./request/req_activite_select_origine2.php'														); }
function majSelOrigine3 (filter_lead) 		{
	majSelect('critere'	,'agence',''	,'selOrigine'		,'./request/req_activite_select_origine3.php?filter_lead=' + (filter_lead === undefined ? 1 : filter_lead));
	if( $('#selOrigine option').length > 0 ) {
		$('#selOrigine').show();
	}
	else {
		$('#selOrigine').hide();
	}
}
function majSelOrigine4 (findId) {
	if( $('#selOrigine option').length ) {
		majSelect('critere'	,'agence', 'selOrigine', 'selOrigine2', './request/req_activite_select_origine4.php' ,findId);
		$('#selOrigine2').show();
	}
	else {
		$('#selOrigine2').hide();
	}
}
function majSelOrigineParent (pere) {
	majSelect('mainmain'	,'client',''	,'pere'		,'./request/req_param_origine_select_parent.php',pere);
}

/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
/* 			Gestion des tableaux pour modification de l'ordre à la volée 	*/
/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
function mvLigne(nomTBody,inputObj,direction,sauvOnFly,url){
	var i=0,
	tr=inputObj.parentNode.parentNode,				// Récupération du TR parent
	tr2,											// Ligne de travail
	tr3,											// Autre ligne à modifier
	mvTr3=1,										// Booléen permettant de savoir si on bouge une autre ligne
	found=false,
	tbody=document.getElementById(nomTBody), 		// Nom du tableau sur lequel travailler
	trs=tbody.getElementsByTagName('tr'), 			// Sélection des éléments <tr> à déplacer
	count=trs.length; 								// Longueur du tableau

	direction=(direction && (direction=='up' || direction=='down'))?direction:'up';
	while(i<count && !found) {
		if(trs[i]==tr) found=true;
		else i++;
	}
	if((i!=0 && direction==='up') || (i!=count-1 && direction==='down')){
		tr3=(direction==='up')?trs[i-1]:trs[i+1];
		tbody.removeChild(tr);
		tr2=(direction==='up')?tbody.insertRow(i-1):tbody.insertRow(i+1);
		tbody.replaceChild(tr,tr2);
	} else {
		mvTr3 = 0;
	}
	if (sauvOnFly==1) {
		majBDD(url, tr.id.substring(2)+','+tr.rowIndex);
		if (mvTr3==1) majBDD(url, tr3.id.substring(2)+','+tr3.rowIndex);
	}
}

/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
/* 					Gestion des tableaux en Javascript 						*/
/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */

/* ------------------------------------------------------------------------ */
/* Nom : ajoutLigne															*/
/* ------------------------------------------------------------------------	*/
/* Description : 	ajoute une ligne avec ses colonnes dans un tableau,  	*/
/*					tous les éléments sont passés en paramètres.		 	*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- eleTab : 		id du tableau à manipuler					*/
/*				- listeCol :	contenu à rajouter dans les colonnes sous	*/
/*								forme de tableau							*/
/*				- classeLigne :	classe css à appliquer à la ligne			*/
/*				- classeCol :	classe css à appliquer aux colonnes			*/
/*				- classeBtn :	classe css à appliquer aux colonnes avec 	*/
/*								boutons										*/
/*				- idLigne :		id de la ligne à ajouter					*/
/* ------------------------------------------------------------------------	*/
function ajoutLigne(eleTab, listeCol, classeLigne, classeCol, classeBtn, idLigne, numLigne) {
	var tab 		= document.getElementById(eleTab);
	if (numLigne==undefined || numLigne==0 || numLigne == '' ) numLigne = -1;
	var ligne 		= tab.insertRow(numLigne);
	if (classeLigne!='') ligne.className = classeLigne;
	if (idLigne!='') ligne.id = idLigne;
	var col			= '';
	for (i=0;i<listeCol.length;i++) {
		col 			= ligne.insertCell(i);
		col.innerHTML 	= listeCol[i];
		if (classeCol!='') col.className	= classeCol;
	}
}

/* ------------------------------------------------------------------------ */
/* Nom : supprLigne															*/
/* ------------------------------------------------------------------------	*/
/* Description : 	supprime une ligne d'un tableau passé en paramètre 		*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- eleTab : 		id du tableau à manipuler					*/
/*				- numLigne :	numéro de la ligne à supprimer				*/
/* ------------------------------------------------------------------------	*/
function supprLigne(eleTab, numLigne) {
	var tab 	= document.getElementById(eleTab);
	tab.deleteRow(numLigne);
}


/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */
/* 					Gestion des select & radios 	 						*/
/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */

/* ------------------------------------------------------------------------ */
/* Nom : getEltSelect														*/
/* ------------------------------------------------------------------------	*/
/* Description : 	renvoie la liste des éléments sélectionnés 				*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- nameElt : nom du champ à manipuler						*/
/* ------------------------------------------------------------------------	*/
function getEltSelect(nameElt) {
	var form = document.getElementById(nameElt);
	var formElems = form.getElementsByTagName('input');
	var ele='';
	var nbEle=0;
	for (var j = 0; j < formElems.length; j++) {
		if (formElems[j].type == 'checkbox' && formElems[j].checked==true) {
			if (nbEle>0) ele+=',';
			ele+=formElems[j].value;
			nbEle++;
		}
	}
	return ele;
}

/* ------------------------------------------------------------------------ */
/* Nom : getRadioSelect														*/
/* ------------------------------------------------------------------------	*/
/* Description : 	renvoie l'élément sélectionné					 		*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- nameElt : nom du champ à manipuler						*/
/* ------------------------------------------------------------------------	*/
function getRadioSelect(nameElt) {
	var ele = '';
	var radios = document.getElementsByName(nameElt);
	for (var j = 0, length = radios.length; j < length; j++) {
		if (radios[j].checked) {
			ele = radios[j];
			break;
		}
	}
	return ele;
}

function jump(h){
    var top = document.getElementById(h).offsetTop; //Getting Y of target element
    window.scrollTo(0, top);                        //Go there.
}

/* ------------------------------------------------------------------------ */
/* Nom : openOverlay														*/
/* ------------------------------------------------------------------------	*/
/* Description : 	renvoie l'élément sélectionné					 		*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	NA															*/
/* ------------------------------------------------------------------------	*/
function openOverlay() {
	var idDiv = "overlayFooter";
	$("#"+idDiv).overlay(
		{ 	top: 100
			, mask: { color: '#fff', loadSpeed: 200, opacity: 0.5 }
			, closeOnClick: true
			, load: true
			, onBeforeLoad: function() {
				$("#"+idDiv).load("contactForm.php");
			}
		}
	).load();
}

function closeOverlay(idDiv) {
	$("#"+idDiv).overlay().close();
}



function majCheckboxUtilateurs(mode) {
	// mode : 	0 - pas de rafraichissement après chargement
	// 			1 - rafraichissement de la page après chargement
	var cr 		= new Array;
	var crit 	= "";
	var i 		= 0;

	cr[i] = gid("dateDeb");
	crit=crit+"&qr"+i+"="+cr[i].value;
	i++;

	cr[i] = gid("dateFin");
	crit=crit+"&qr"+i+"="+cr[i].value;
	i++;

	crit=crit+"&qr"+i+"="+mode;
	i++;

	// Récupération du type de regroupement
	if (gid("regroupAff")!=undefined) {
		cr[i] = gid("regroupAff");
		crit=crit+"&qr"+i+"="+cr[i].value;
	} else crit=crit+"&qr"+i+"=2";
	i++;

	// Récupération du type d'affichage
	if (gid("typeAff")!=undefined) {
		cr[i] = gid("typeAff");
		crit=crit+"&qr"+i+"="+cr[i].value;
	} else crit=crit+"&qr"+i+"=2";
	i++;

    majDivAvecScript("filtreSuppRes","./request/req_checkbox_ressources.php",crit);
}

// Export d'un tableau html vers Excel
function exportTableToCSV($table, filename) {

	var $rows = $table.find('tr:has(td)'),
		tmpColDelim = String.fromCharCode(11),
		tmpRowDelim = String.fromCharCode(0),
		colDelim = '";"',
		rowDelim = '"\r\n"',

		csv = '"' + $rows.map(function (i, row) {
			var $row = $(row),
				$cols = $row.find('td');

			return $cols.map(function (j, col) {
				var $col = $(col),
					text = $col.text();

				return text.replace('"', '""');

			}).get().join(tmpColDelim);

		}).get().join(tmpRowDelim)
			.split(tmpRowDelim).join(rowDelim)
			.split(tmpColDelim).join(colDelim) + '"',

		csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv);

	$(this).attr({'download': filename,'href': csvData,'target': '_blank'});

}

// Return a helper with preserved width of cells
var fixHelper = function(e, ui) {
	ui.children().each(function() {
		$(this).width($(this).width());
	});
	return ui;
};

function activeCheckbox(idEle) {
	var cases = $("#"+idEle).find(':checkbox');
	cases.removeAttr("disabled");
}

/* ------------------------------------------------------------------------ */
/* Nom : majTri																*/
/* ------------------------------------------------------------------------	*/
/* Description : tri un tableau 											*/
/* ------------------------------------------------------------------------	*/
/* Paramètres :	- col : colonne												*/
/*				- ele :	élément												*/
/* ------------------------------------------------------------------------	*/
function majTri(col,ele,fct) {
	if (col==gid("triCol").value) {
		if (gid("triOrdre").value == "ASC") {
			gid("triOrdre").value = "DESC";
		} else {
			gid("triOrdre").value = "ASC";
		}
	} else {
		gid("triCol").value 	= col;
		gid("triOrdre").value 	= "ASC";
	}

	if (fct>0) {
		if (fct==2) maj_result2();
		if (fct==3) maj_result3();
		if (fct==4) maj_result4();
	} else maj_result(1)
}

function init_date_picker (pickerId, dateInit, func, majRechNom, majRechProd, majRechRef, majUtil, page) {
	$("#"+pickerId).datepicker({
		onSelect: function() {
			if (func!="") window[func]();
			if (page == "") {
				if (majRechNom == 1) maj_recherche_nom(1);
				if (majRechProd == 1) maj_recherche_produit(1);
				if (majRechRef == 1) maj_recherche_ref(1);
				if (majUtil == 1) majSelect('critere', '', '', 'util', './request/req_activite_select_user.php', gid("client").value, '', gid("dateDeb").value, gid("dateFin").value);
			}
			if (page == 'rep_activite' || page == "reporting" || page == "creditcomm" || page == "rep_sinistres" || page == "syntheseprod") {
				majCheckboxUtilateurs(1);
			}
		}
		, changeMonth: true
		, changeYear: true
		, showOtherMonths: true
		, selectOtherMonths: true
	});
	$('#'+pickerId+'Btn').click(function() {
		$('#'+pickerId).datepicker('show');
	})
	$("#"+pickerId).mask("99/99/9999");
	$("#"+pickerId).datepicker("setDate",dateInit);
	$("#ui-datepicker-div").hide();
}

function init_date_picker_simple (pickerId, func, hours) {
	$('[id^="'+pickerId+'"]').datepicker({
		showOn: "button"
		, buttonText: ''
		, onSelect: function(datetext) {
			if (func=="suivicontrat") {
				id = $(this).attr('id').substr(8);
				changeDate(id);
				verifValid(id);
			}
			if (hours!=undefined && hours ==1) {
				var d = new Date(); // for now
				var h = d.getHours();
				h = (h < 10) ? ("0" + h) : h ;
				var m = d.getMinutes();
				m = (m < 10) ? ("0" + m) : m ;
				datetext = datetext + " " + h + ":" + m;
				$(this).val(datetext);
			}
		}
		, changeMonth: true
		, changeYear: true
		, showOtherMonths: true
		, selectOtherMonths: true
	});
	$("#ui-datepicker-div").hide();
	if (hours!=undefined && hours == 1) $('[id^="'+pickerId+'"]').mask("99/99/9999 99:99");
	else $('[id^="'+pickerId+'"]').mask("99/99/9999");
}

function on_date_recherche_changed($btn, $dateDeb, $dateFin) {
    var dateInit = new Date();
    var annee   = dateInit.getFullYear();
    var mois    = dateInit.getMonth()+1;
    var jour    = dateInit.getDate();
    var jourDeb, moisDeb, jourFin, moisFin;

    switch ($btn.prop('id')) {
        case 'btnAnnee':
            numBtn = 1;
            jourDeb     = 1;
            moisDeb     = 1;
            anneeDeb    = annee;
            jourFin     = jour;
            moisFin     = mois;
            anneeFin    = annee;
            break;
        case 'btnMois':
            numBtn = 2;
            jourDeb     = 1;
            moisDeb     = mois;
            anneeDeb    = annee;
            jourFin     = jour;
            moisFin     = mois;
            anneeFin    = annee;
            break;
        case 'btnSem':
            numBtn = 3;
            var firstDayOfWeek = premierJourSemaine(dateInit);
            jourDeb     = firstDayOfWeek.getDate();
            moisDeb     = firstDayOfWeek.getMonth()+1;
            anneeDeb    = firstDayOfWeek.getYear();
            jourFin     = jour;
            moisFin     = mois;
            anneeFin    = annee;
            break;
        case 'btnNow':
            numBtn = 4;
            jourDeb     = jour;
            moisDeb     = mois;
            anneeDeb    = annee;
            jourFin     = jour;
            moisFin     = mois;
            anneeFin    = annee;
            break;
    }

    if (moisDeb < 10) moisDeb = '0'+moisDeb;
    if (jourDeb < 10) jourDeb = '0'+jourDeb;
    if (moisFin < 10) moisFin = '0'+moisFin;
    if (jourFin < 10) jourFin = '0'+jourFin;

    $dateDeb.val(jourDeb+'/'+moisDeb+'/'+annee);
    $dateFin.val(jourFin+'/'+moisFin+'/'+annee);
}

function init_aide() {
	$( document ).tooltip({
		items: "#aide",
		content: function() {
			var element = $( this );
			return $("#aideContenu").html();
		},
		position: { my: "top+15", at: "center" }
	});
}

var fddeb = function changeDDeb() {
	if ($("#dateFin").datepicker( "getDate" )-$("#dateDeb").datepicker( "getDate" )<0)
		$("#dateFin").datepicker( "setDate", $("#dateDeb").datepicker( "getDate" ));
	if (document.getElementById('util')!=undefined) 	majUtil(document.getElementById('util').value);
};

var fdfin = function changeDFin() {
	if ($("#dateFin").datepicker( "getDate" )-$("#dateDeb").datepicker( "getDate" )<0)
		$("#dateDeb").datepicker( "setDate", $("#dateFin").datepicker( "getDate" ));
	if (document.getElementById('util')!=undefined) 	majUtil(document.getElementById('util').value);
};

function maj_recherche_fournisseur(page) {
	if (page=='') page=1;
	var cr = new Array;
	var crit = "page="+page; var opt = "";

	$('#filtreFournisseur').typeahead('destroy');
	$('#filtreFournisseur').typeahead(null, {
		display: 'value',
		//async: true,
		source: function ( query, syncResult, asyncResult ) {
			$.ajax({
				url:'/request/filtre_fournisseurs.php?query='+query+'&'+crit+opt,
				dataType:'json',
				success:function( data ) {
					asyncResult(data);
				},
			});
		},
	});

	$('#filtreFournisseur').bind('typeahead:select', function(ev, product) {
		$('#filtreFournisseurId').val(product.id);
	});

	if( $("#filtreFournisseurId").val() ) {
		// init : retrieve the label of the selected id
		$.ajax({
			url:'/request/filtre_fournisseurs.php?id='+$("#filtreFournisseurId").val(),
			dataType:'json',
			success:function( data ) {
				if( data.length ) {
					$('#filtreFournisseur').typeahead('val', data[0].value);
				}
			},
		});
	}
}

function serializeArray($form)
{
	var data = $form.find(':input').not('.inpTime').serializeArray();

    data = data.concat(
        $form.find('input.inpTime').map(function () {
            var dateUnformated = $form.find('input[name=' + this.name + ']').datepicker('getDate');
            if (dateUnformated != null) {
                return {
                    name: this.name,
                    value: dateUnformated.toCarbon()
                };
            }
        }).get()
    );

    return data;
}
